import script from "./OrdersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrdersView.vue?vue&type=script&setup=true&lang=ts"

import "./OrdersView.vue?vue&type=style&index=0&id=39010663&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39010663"]])

export default __exports__